module.exports = __webpack_public_path__ + "img/brandme_logo_gray.f42088c6.png";